const _ = require('lodash');
const background = document.querySelector('[data-color]');

if (document.body.contains(background)) {

    function backgroundScroll() {
        const container = document.querySelectorAll('[data-color]');
        const scroll = window.scrollY + (window.innerHeight / 2);
                    
        for (let i = 0; i < container.length; i++) {
                    
            const offsetEl = offset(container[i]);
            if (offsetEl.top <= scroll && offsetEl.top + container[i].clientHeight > scroll) {
                const backgroundColour = container[i].dataset.color; 
                removeClassByPrefix(document.body, 'bg-');            
                document.body.classList.add('bg-' + backgroundColour);
            }    
        
        }
        
    }
    
    // Calculate the Offset
    function offset(el) {
        var rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
    }
    
    // Remove class 
    function removeClassByPrefix(node, prefix) {
    	var regx = new RegExp('\\b' + prefix + '[^ ]*[ ]?\\b', 'g');
    	node.className = node.className.replace(regx, '');
    	return node;
    }
    
    window.addEventListener('scroll', _.throttle(backgroundScroll, 50), false);

}